import _ from "lodash";
import {getActionData} from "_helpers";
import {alertMessages, customFieldConstants, macroConstants} from "_constants";
import {macroService} from "_services";
import {Auth} from "../components/Authorization";
import {SnackBar} from "../components/common";

function fetchMacro(params) {
    return (dispatch) => {
        dispatch(getActionData(macroConstants.FETCH_MACRO_REQUEST));
        macroService.fetchMacro(params)
            .then(response => {
                dispatch(getActionData(macroConstants.FETCH_MACRO_SUCCESS, response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(macroConstants.FETCH_MACRO_FAILURE, {}, error));
            SnackBar.showMessage(alertMessages.FETCH_MACRO_ERROR);
        });
    }
}

function resetMacros() {
    return (dispatch) => {
        dispatch(getActionData(macroConstants.CLEAR_MACROS));
    }
}

export const macroActions = {
    fetchMacro,
    resetMacros
};